class ProductAddon extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.modalTrigger = this.querySelector('.addon-modal-trigger');
    if(!this.modalTrigger) return;
    
    this.modal = this.querySelector(`#${this.modalTrigger.dataset.modal}`);
    this.modalCloseTrigger = this.querySelector(`#${this.modalTrigger.dataset.modal}__popup-close-btn`);
    this.productVariants = JSON.parse(this.querySelector(`#addonJson-${this.dataset.productId}`));
    this.addonRemoveButton = this.querySelector('.product-addons__remove');
    this.selectedValueEle = this.querySelector('.product-addons__selected-value');
    this.addonForm = this.querySelector('product-addon-form');
    this.init();
  }

  init() {
    // open the modal
    // this.modalTrigger.addEventListener('click', e => {
    //   e.stopPropagation();
    //   this.modal.classList.remove('hidden');
    // });

    // // close the modal
    // this.modalCloseTrigger.addEventListener('click', e => {
    //   e.preventDefault();
    //   this.modal.classList.add('hidden');
    // });
    this.addonRemoveButton.addEventListener('click', this.removeButtonClickHandler.bind(this));
  }

  getSelectedVariant() {
    const productOptionsEle = this.querySelector('product-options') || this.querySelector('product-addon-toggle');
    return productOptionsEle.currentVariant || null;
  }

  removeButtonClickHandler(e) {
    const selectedEles = this.querySelectorAll('.addon-single-option__selector input[type="radio"]:checked');
    selectedEles.forEach(el => {
      el.checked = false;
      el.removeAttribute('checked')
    });

    const productOptionsEle = this.querySelector('product-options') || this.querySelector('product-addon-toggle');
    productOptionsEle.currentVariant = null;

    this.selectedValueEle.textContent = '';
    this.addonForm.priceChanged();
  }
}

customElements.define('product-addon', ProductAddon);

class ProductAddonToggle extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.checkbox = this.querySelector('[type="checkbox"]');
    const productJson = this.closest('product-addon').querySelector(`#addonJson-${this.dataset.productId}`).innerHTML;
    this.productVariants = JSON.parse(productJson);
    this.parentProductSection = this.closest('[data-section-type="product"]');
    this.currentVariant = null;
    this.init();
  }

  init() {
    this.checkbox.addEventListener('change', this.toggleStateChangeHandler.bind(this))
  }

  toggleStateChangeHandler(e) {
    if(e.currentTarget.checked) {
      this.currentVariant = this.productVariants[0];
    } else {
      this.currentVariant = null;
    }

    const _ts = theme.sections.instances.find(e => e.container === this.parentProductSection);
    if(_ts) {
      const currentVariant = _ts.variants.currentVariant;
      // document.querySelector("[data-variant-input]").dispatchEvent(new Event("change"));
      _ts.container.dispatchEvent(new CustomEvent("variantPriceChange", {
        detail: {
          variant: currentVariant,
        },
      }));
    }
  }
}

customElements.define('product-addon-toggle', ProductAddonToggle);

class ProductOptions extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.singleOptionWrapper = this.querySelectorAll('.addon-single-option__selectors');
    this.singleOptionSelectors = this.querySelectorAll('.addon-single-option__selector input[type="radio"]');
    const productJson = this.querySelector(`#addonJson-${this.dataset.productId}`).innerHTML;
    this.productVariants = JSON.parse(productJson);
    this.currentVariant = null;
    this.init();
  }

  init() {
    // open the modal
    this.singleOptionSelectors.forEach(selector => {
      selector.addEventListener('click', this.onProductOptionChange.bind(this));
    });
  }

  getCurrentlySelectedOptions() {
    const options = [];
    this.singleOptionSelectors.forEach(el => {
      const type = el.getAttribute('type');
  
      if (type === 'radio' || type === 'checkbox') {
        if (el.checked) {
          options.push({
            value: el.value,
            index: el.dataset.index
          });
        }
      } else {
        options.push({
          value: el.value,
          index: el.dataset.index
        });
      }
    });

    return options;
  }

  findVariantFromSelectedOptions(needsToBeAvailable = true) {
    const currentlySelectedOptions = this.getCurrentlySelectedOptions();

    const variants = this.productVariants;

    return variants.find(variant => {
      const isMatch = currentlySelectedOptions.every(({value, index}) => {
        return variant[index] === value;
      });

      if (needsToBeAvailable) {
        return isMatch && variant.available;
      } else {
        return isMatch;
      }
    });
  }

  onProductOptionChange(e) {
    const selector = e.target;
    
    this.currentVariant = this.findVariantFromSelectedOptions(true);

    if(!this.currentVariant) return;

    // update/change the price
    const priceEle = this.querySelector('.addon-option-price');
    priceEle.textContent = theme.Currency.formatMoney(this.currentVariant.price, theme.settings.moneyFormat);
  }
}

customElements.define('product-options', ProductOptions);

class ProductAddonForm extends HTMLElement {
  constructor() {
    super();
    this.proceedButton = this.querySelector('.proceed-btn');
    this.parentProductSection = this.closest('[data-section-type="product"]');

    this.init();
  }

  init() {
    this.proceedButton.addEventListener('click', (e) => {
      e.preventDefault();
      const slideoutModalEle = this.closest('slideout-modal');
      const productOptionsEle = slideoutModalEle.querySelector('product-options');

      const productAddonEle = this.closest('product-addon');
      const selectedValueEle = productAddonEle.querySelector('.product-addons__selected-value');

      if(productOptionsEle.currentVariant) {
        if(selectedValueEle) {
          selectedValueEle.textContent = productOptionsEle.currentVariant.title;
          
          // update price
          const priceEle = productAddonEle.querySelector('.addon-price');
          priceEle.textContent = theme.Currency.formatMoney(productOptionsEle.currentVariant.price, theme.settings.moneyFormat);
        }
      }

      this.priceChanged();
      
      slideoutModalEle.close();
    })
  }

  priceChanged() {
    const _ts = theme.sections.instances.find(e => e.container === this.parentProductSection);
    if(_ts) {
      const currentVariant = _ts.variants.currentVariant;
      _ts.container.dispatchEvent(new CustomEvent("variantPriceChange", {
        detail: {
          variant: currentVariant,
        },
      }));
    }
  }
}

customElements.define('product-addon-form', ProductAddonForm);